import { Phone, MapPin } from "lucide-react";
import { CONTACT } from "@/config/site";
import { Logo } from "./Header";

const LINKS = [["types", "Solar Types"], ["categories", "Categories"], ["pm-yojana", "PM Surya Ghar"], ["why", "Why Us"], ["contact", "Contact"]];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-navy-950 pb-28 pt-16">
    <div className="container-x grid gap-10 md:grid-cols-3">
      <div>
        <Logo testId="footer-logo" dark />
        <p className="mt-5 max-w-xs text-lg text-slate-400">सोलर लगवाएं, बिजली बिल बचाएं. Trusted in Unnao for 16+ years.</p>
      </div>
      <div>
        <h4 className="font-display text-lg font-bold text-white">Quick Links</h4>
        <ul className="mt-4 grid grid-cols-2 gap-3">
          {LINKS.map(([id, l]) => (
            <li key={id}><a href={`#${id}`} data-testid={`footer-link-${id}`} className="text-slate-400 hover:text-gold transition-colors">{l}</a></li>
          ))}
        </ul>
      </div>
      <div className="space-y-3">
        <h4 className="font-display text-lg font-bold text-white">Contact</h4>
        <a href={CONTACT.tel} data-testid="footer-phone-link" className="flex items-center gap-2 text-lg text-slate-200 hover:text-gold"><Phone className="h-5 w-5 text-gold" />{CONTACT.phoneDisplay}</a>
        <p className="flex items-start gap-2 text-slate-400"><MapPin className="mt-1 h-5 w-5 shrink-0 text-gold" />{CONTACT.address}</p>
      </div>
    </div>
    <div className="container-x mt-12 flex flex-col sm:flex-row justify-between gap-3 border-t border-white/10 pt-6 text-sm text-slate-500">
      <span>© {new Date().getFullYear()} Anuj Saur Urja Sales. All rights reserved.</span>
      <a href="/admin" data-testid="footer-admin-link" className="hover:text-slate-300">Admin</a>
    </div>
  </footer>
);
